var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"scrim":false,"persistent":"","width":"auto","content-class":"overview-loader"},model:{value:(_vm.loader),callback:function ($$v) {_vm.loader=$$v},expression:"loader"}},[_c('div',{staticClass:"overview-loader__inner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":50,"color":"#857FD3"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }